export var Name = 'update-payment-provider';
export var UpdatePaymentProviderEvent = Name;